// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-3i-q4kUG"};